export function AboutPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">About nickfixit</h1>
      <p className="text-gray-600">Learn more about our self-hosting services...</p>
    </div>
  )
}